import {CurrencyCode, currencyFormatPrice, LanguageCodes, Price} from '@wix/devzai-utils-common';

export interface DoppeActionPrice {
    actualPrice: number;
    discountPrice?: number;
    currencyCode: CurrencyCode;
}

export function doppeActionPriceGetActualPrice (actionPriceData: DoppeActionPrice) {
    return actionPriceData.actualPrice
}

export function doppeActionPriceGetDiscountPrice (actionPriceData: DoppeActionPrice) {
    return actionPriceData.discountPrice
}


export function doppeActionPriceGetFormattedPrice (actionPriceData: DoppeActionPrice, locale: LanguageCodes) {
    return  currencyFormatPrice({
        code: actionPriceData.currencyCode,
        price: actionPriceData.actualPrice,
        removeFractionWhenPossible: true,
        locale: locale,
    })
}

export function doppeActionPriceConvertActionPriceToPrice(price: DoppeActionPrice) {
    return {
        amount: price.discountPrice ?? price.actualPrice,
        currencyCode: price.currencyCode
    } satisfies Price;
}